export const all_routes = {
  // home module path
  homeOne: '/home-two',
  index: '/home',
  homeTwo: '/home-three',
  homeThree: '/home-four',
  homeFour: '/home-five',
  homeFive: '/home-six',
  homeSix: '/home-seven',
  homeSeven: '/home-eight',
  homeEight: '/home-nine',
  homeNine: '/home-ten',

  // blog module path
  blog: '/blog/*',
  blogDetails: '/blog/blog-details',
  blogGrid: '/blog/blog-grid',
  blogList: '/blog/blog-list',


  // services module path
  services: '/services/*',
  serviceGrid: '/services/service-grid',
  serviceList: '/services/service-list',
  createService: '/services/create-service',
  providerDetails: '/services/providers/provider-details',
  search: '/services/search',
  serviceRequest: '/services/service-request',
  searchList: '/services/search-list',
  provider: '/services/providers/provider-list',
  serviceDetails1: '/services/service-details/service-details1',
  serviceDetails2: '/services/service-details/service-details2',

  // customers module path
  customers: '/customers/*',
  customerDashboard: '/customers/customer-dashboard',
  customerBooking: '/customers/customer-booking',
  customerFavourite: '/customers/customer-favourite',
  customerNotifications: '/customers/customer-notifications',
  customerProfile: '/customers/settings/customer-profile',
  customerSecurity: '/customers/settings/customer-security',
  customerNotification: '/customers/settings/notification',
  customerConnectedApps: '/customers/settings/connected-apps',
  customerBookingCalendar: '/customers/customer-booking-calendar',
  customerChat: '/customers/customer-chat',
  customerReviews: '/customers/customer-reviews',
  customerWallet: '/customers/customer-wallet',
  deviceManagement: '/customers/settings/device-management',
  customerLoginActivity: '/customers/settings/login-activity',

  commonNotification: '/customers/notification',

  // providers module path
  providers: '/providers/*',
  providerAddon: '/providers/provider-addon',
  verfication: '/providers/settings/verification',
  providerPlan: '/providers/settings/provider-plan',
  providerProfileSettings: '/providers/settings/provider-profile-settings',
  paymentSetting: '/providers/settings/payment-setting',
  connectedApp: '/providers/settings/connected-app',
  providerEditService: '/providers/provider-edit-service',
  providerHoliday: '/providers/provider-holiday',
  providerNotification: '/providers/settings/provider-notification',
  providerOffer: '/providers/provider-offer',
  providerDeviceManagement: '/providers/settings/provider-device-management',
  providerLoginActivity: '/providers/settings/provider-login-activity',
  providerEarnings: '/providers/provider-earnings',
  providerAppointmentSettings:
    '/providers/settings/provider-appointment-settings',
  providerConnectedApps: '/providers/settings/provider-connected-apps',
  providerAvailability: '/providers/provider-availability',
  providerBookDetails: '/providers/provider-book-details',
  providerBooking: '/providers/provider-booking',
  providerChat: '/providers/provider-chat',
  providerCoupons: '/providers/provider-coupons',
  providerDashboard: '/providers/dashboard',
  providerSignup: '/authentication/provider-signup',
  providerSignupPayment: '/providers/authentication/provider-signup-payment',
  providerSignupSubscription:
    '/providers/authentication/provider-signup-subscription',
  providerSocialProfile: '/providers/settings/provider-social-profile',
  providerSubscription: '/providers/provider-subscription',
  providerPayout: '/providers/provider-payout',
  providerReview: '/providers/provider-review',
  providerService: '/providers/provider-service',
  providerServiceList: '/providers/provider-service-list',
  ProviderSecuritySettings: '/providers/settings/provider-security-settings',
  ProviderEarnings: '/providers/provider-earnings',
  addSubscription: '/providers/add-subscription',
  staffList: '/providers/staff/staff-list',
  staffGrid: '/providers/staff/staff-grid',
  staffDetails: '/providers/staff/staff-details',
  customerDetails: '/providers/customer/customer-details',
  customerList: '/providers/customer/customer-list',
  customerGrid: '/providers/customer/customer-grid',
  providerTransaction: '/providers/provider-transaction',
  providerLeaveHistory: '/providers/leave-history',
  providerEnquiry: '/providers/provider-enquiry',

  // pages module path
  pages: '/pages/*',
  aboutUs: '/pages/about-us',
  error404: '/authentication/error-404',
  error500: '/authentication/error-500',
  faq: '/pages/faq',
  howItWorks: '/pages/how-it-works',
  termsCondition: '/pages/terms-condition',
  booking1: '/pages/booking/booking-1',
  bookings: '/pages/booking',
  booking2: '/customers/user-bookings',
  bookingDetails: '/pages/booking/booking-details',
  invoice: '/pages/invoice',
  bookingDone: '/customers/booking-done',
  bookingPayment: '/customers/booking-payment',
  contactUs: '/pages/contact-us',
  comingSoon: '/pages/coming-soon',
  categories: '/pages/categories',
  categories2: '/pages/categories-2',
  chooseSignUp: '/authentication/choose-signup',
  emailOtp: '/authentication/email-otp',
  userSignup: '/authentication/user-signup',
  login: '/authentication/login',
  loginemail: '/authentication/login-email',
  loginphone: '/authentication/login-phone',
  loginphone1: '/authentication/login-phone1',
  freeTrail: '/authentication/free-trail',
  passwordRecovery: '/authentication/forgot-password',
  phoneOtp: '/authentication/phone-otp',
  privacyPolicy: '/pages/privacy-policy',
  pricingPlan: '/pages/pricing-plan',
  sessionExpired: '/pages/session-expired',
  maintenance: '/pages/maintenance',
  installer: '/pages/installer',
  success: '/authentication/success',
  resetPassword: '/authentication/reset-password',
  forgotPassword: '/authentication/forgot-password',

  test: '',

  // Admin Module Path

  admin: '/*',
  abuseReport: '/support/abuse-reports',
  contactMessages: '/support/contact-messages',
  contactMessagesView: '/support/contact-messages-view',
  countries: '/location/countries',
  cities: '/location/cities',
  state: '/location/state',
  connectedApps: '/setting/connected-apps',
  cashOnDelivery: '/finance-accounts/cash-on-delivery',
  chat: '/chat',
  completedBooking: '/booking/completed-booking',
  pendingBooking: '/pending-booking',
  banIpAddress: '/setting/ban-ip-address',
  bankTransferList: '/finance-accounts/bank-transferlist',
  calendarSetting: '/setting/calendar-settings',
  blogCategories: '/blog-categories',
  coupons: '/marketing/coupons',
  cronJob: '/setting/cronjob',
  curriencies: '/setting/currencies',
  createMenu: '/management/create-menu',
  userCustomer: '/user/customers',
  adminEarnings: '/reports-earnings',
  allBlog: '/blog/all-blog',
  approvedTransferlist: '/finance-accounts/approved-transferlist',
  appearance: '/setting/appearance',
  accountSettings: '/setting/account-settings',
  emailSettings: '/setting/email-settings',
  appointmentSettings: '/setting/appointment-settings',
  authenticationSettings: '/setting/authentication-settings',
  announcements: '/support/announcements',
  currencySettings: '/setting/currency-settings',
  customerWallets: '/customer-wallet',
  availablePlugins: '/plugin/available-plugins',
  payoutRequest: '/payouts/payout-request',
  payoutSettings: '/payouts/payout-settings',
  paymentSettings: '/setting/payment-settings',
  paymentGateway: '/setting/payment-gateways',
  headerSettings: '/setting/header-settings',
  inActiveBlog: '/blog/inactive-blog',
  inActiveServices: '/services/inactive-services',
  addServices: '/services/add-service',
  allServices: '/services/all-services',
  editService: '/services/edit-service',
  inProgressBooking: '/booking/inprogress-booking',
  pendingServices: '/services/pending-services',
  dashboard: '/dashboard',
  websiteSettings: '/management/website-settings',
  emailNewsletter: '/marketing/email-newsletter',
  language: '/setting/language',
  loginActivity: '/setting/login-activity',
  localization: '/setting/localization',
  seoSettings: '/setting/seo-settings',
  serviceSettings: '/setting/service-settings',
  siteInformation: '/setting/site-information',
  smsSettings: '/setting/sms-settings',
  menuManagement: '/management/menu-management',
  salesReport: '/reports/service-sales',
  socialAuthentication: '/setting/social-authentication',
  socialProfile: '/setting/social-profile',
  taxRates: '/setting/tax-rates',
  typographytSettings: '/setting/typography-settings',
  testimonials: '/content/testimonials',
  wallet: '/finance-accounts/wallet',
  verificationRequest: '/verification-request',
  systemInformation: '/setting/system-information',
  smsTemplate: '/management/sms-template',
  storageSetting: '/setting/storage-settings',
  pluginManager: '/management/plugin-manager',
  preferenceSettings: '/setting/preference-settings',
  providerEarning: '/reports/provider-earnings',
  userProviders: '/users/providers',
  providerSales: '/reports/provider-sales',
  providerSettings: '/setting/provider-settings',
  providerWallet: '/reports/provider-wallet',
  faqadmin: '/content/faq',
  featureServices: '/marketing/featured-services',
  systemBackup: '/setting/system-backup',
  gdpr: '/setting/gdbr',
  emailTemplates: '/management/email-templates',
  review: '/review',
  reviewType: '/review-type',
  roles: '/roles',
  salestransactions: '/finance-accounts/sales-transactions',
  walletHistory: '/wallet-history',
  membershipTransaction: '/reports/membership-transaction',
  addHome: '/pages/add-home',
  addMembership: '/membership/add-membership',
  activeServices: '/services/active-services',
  deletedServices: '/services/deleted-services',
  security: '/setting/security',
  registerreport: '/reports/register-report',
  successTransferlist: '/finance-accounts/successful-transferlist',
  footerSettings: '/setting/footer-settings',
  membership: '/membership',
  membershipaddons: '/memberships/membership-addon',
  users: '/users',
  usersCustomer: '/customers',
  deleteAccountReqest: '/delete-account-requests',
  viewServices: '/view-service',
  pendingBlog: '/blog/pending-blog',
  booking: '/booking',
  cancelledBooking: '/bookings/cancelled-booking',
  editblog: '/edit-blog',
  pendingTransferlist: '/finance-accounts/pending-transferlist',
  rejectedTransferlist: '/finance-accounts/rejected-tranferlist',
  deleteaccountrequests: '/delete-account-requests',
  databasebackup: '/setting/database-backup',
  adminDevicemanagement: '/management/device-management',
  refundReport: '/reports/refund-report',
  providersList: '/services/providers/provider-list',
  refundRequest:'/finance-accounts/refund-request',
  cacheSystem:'/management/cachesystem',
  signin:'/signin',
  logout:'/logout',
  userCustomers:'/users/customers',
  city:'/categories/cities',
  sectorPhase:'/categories/sector-phase',
  mainCategory:'/categories/main-categories',
  subCategories: '/categories/sub-categories',
  sortingTags:'/sorting-tags/tags-list',
  subTags:'/sorting-tags/sub-tags',
  jsonData:'/data/json-data',
  ai_add_listing:'ai-agent/add-listing',
  addPages:'/pages/add-page',
  EditPages:'/edit-page',
  viewService:'/view-listing',
  permissions:'/permissions',
  offer:'/marketing/offer',
  adminNotification:'/setting/notification',
  pagesList: '/pages-list',
  pageList: '/page-list',
  addBlog: '/blog/add-blog',
  blogsCategories: '/blog/blog-categories',
  blogComments: '/blog/blog-comments',
  adminCustomerWallet: '/reports/customer-wallet',
  addPage: '/pages/add-pages',

};